module.exports = __webpack_public_path__ + "static/media/next_arrow_dark.1179ba03.svg";